import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { KarteUserProfileUserFragmentDoc } from './KarteUserProfile.generated';
import { KarteUserDetailedProfileDiagnosisFragmentDoc } from './KarteUserDetailedProfile.generated';
export type KarteUserListItemKarteFragment = { __typename?: 'Karte', id: string, isLikelyToMatch: boolean, hasCommentsFromPlannersBelongingToSameBranch: boolean, userComment: string, numberOfPlannerComments: number, modifiedAt: TimeString, topics: Array<{ __typename?: 'KarteTopic', id: string, name: string }>, ownKartePlannerComment?: { __typename?: 'KartePlannerComment', id: string } | null, user: { __typename?: 'User', id: string, nickname: string, channel: Types.Channel, livingPrefecture?: Types.Prefecture | null, birthYear?: number | null, gender: Types.UserGender, numberOfMatch: number, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null }, diagnosis: { __typename?: 'Diagnosis', annualIncome: number, saving: number, monthlyInsurance: number, investment: number, partner?: { __typename?: 'DiagnosisPartner', birthYear: number, annualIncome: number } | null, children: Array<{ __typename?: 'DiagnosisChild', age: number, gender: Types.Gender }> } };

export const KarteUserListItemKarteFragmentDoc = gql`
    fragment KarteUserListItemKarte on Karte {
  id
  isLikelyToMatch
  hasCommentsFromPlannersBelongingToSameBranch
  topics {
    id
    name
  }
  userComment
  numberOfPlannerComments
  ownKartePlannerComment {
    id
  }
  modifiedAt
  user {
    ...KarteUserProfileUser
  }
  diagnosis {
    ...KarteUserDetailedProfileDiagnosis
  }
}
    ${KarteUserProfileUserFragmentDoc}
${KarteUserDetailedProfileDiagnosisFragmentDoc}`;